import React from "react";
import SbButton from "uiCore/SbButton/SbButton";
import { BUTTON_TYPE_DEFAULT } from "constants/ui.constants";
import { TEXT } from "../../GroupSkillsProficiencyV2.constants";
import {
  ScaleFooterContainerStyled,
  ScaleHeadingStyled,
  ScaleItemsRowStyled,
  ScaleItemTextStyled,
} from "./ScaleProficiencyFooter.styles";

const ScaleProficiencyFooter = ({ scaleData, onViewDetails }) => {
  if (!scaleData?.proficiency_scale) return null;

  return (
    <ScaleFooterContainerStyled>
      <ScaleHeadingStyled>{TEXT.SCALE_HEADING}</ScaleHeadingStyled>

      {/* Flex props: wrap + align + gap. styled adds only margin-top. */}
      <ScaleItemsRowStyled wrap="wrap" align="center" gap={16}>
        {scaleData.proficiency_scale.map((field, i) => (
          <ScaleItemTextStyled key={i}>
            {field.level}
            {TEXT.SCALE_SEPARATOR}
            <strong>{field.name}</strong>
          </ScaleItemTextStyled>
        ))}
        <SbButton buttonType={BUTTON_TYPE_DEFAULT} onClick={onViewDetails}>
          {TEXT.BTN_VIEW_DETAILS}
        </SbButton>
      </ScaleItemsRowStyled>
    </ScaleFooterContainerStyled>
  );
};

export default ScaleProficiencyFooter;
